var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name !== (_vm.to.toLowerCase()))?_c('router-link',{attrs:{"to":'/'+_vm.$i18n.locale+'/'+(_vm.to.toLowerCase().replace(/ /gm,''))}},[_vm._t("default")],2):_c('a',{attrs:{"href":"#app","uk-scroll":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }